import { SmbContent } from 'shared/components/SmbPage';
import { FaqContainer } from 'shared/containers/Faq';
import { SocialsContainer } from 'shared/containers/Socials';
import { StepsContainer } from 'shared/containers/Steps';
import { TStep } from 'shared/types/carousel';
import type { TFaqItem } from 'shared/types/faq';
import type { TSocialItem } from 'shared/types/socials';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { StartBlockContainer } from '../StartBlock';

export const SmbContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const steps = config.get<TStep[]>('b2b-marketing-guide-frontend.smb.steps') ?? [];
  const faqItems = config.get<TFaqItem[] | null>('b2b-marketing-guide-frontend.smb.faq');
  const socialItems = config.get<TSocialItem[] | null>('b2b-marketing-guide-frontend.smb.socials');
  const faq = faqItems?.length ? <FaqContainer items={faqItems} /> : null;
  const socials = socialItems?.length ? <SocialsContainer items={socialItems} /> : null;

  return (
    <SmbContent
      startBlock={<StartBlockContainer />}
      steps={<StepsContainer steps={steps} />}
      faq={faq}
      socials={socials}
    />
  );
};
